// Desteklenen diller ve fallback sırası
export const SUPPORTED_LANGS = ['tr', 'en'];
export const DEFAULT_LANG = 'tr';
export const FALLBACKS = ['tr', 'en']; // sırayla dene

// Başlangıç dili (localStorage > <html lang> > navigator > default)
export function getInitialLang() {
  const ls = localStorage.getItem('lang');
  if (ls && SUPPORTED_LANGS.includes(ls)) return ls;

  const htmlLang = document.documentElement.lang?.toLowerCase();
  if (SUPPORTED_LANGS.includes(htmlLang)) return htmlLang;

  const nav = navigator.language?.slice(0,2).toLowerCase();
  if (SUPPORTED_LANGS.includes(nav)) return nav;

  return DEFAULT_LANG;
}

// translations objesinden dil seç ve fallback uygula
export function pickTrans(translations, lang, fallbacks = FALLBACKS) {
  if (!translations || typeof translations !== 'object') return null;
  return translations[lang]
      || fallbacks.map(f => translations[f]).find(Boolean)
      || Object.values(translations)[0]
      || null;
}

// Objeyi "dil uygulanmış" hale getir (base alanları + seçili dil alanları birleştir)
export function localizeNode(node, lang) {
  if (!node || typeof node !== 'object') return node;
  const { translations, ...base } = node;
  const t = pickTrans(translations, lang) || {};
  return { ...base, ...t };
}

// Dosya URL’lerini normalize et (absolute ise dokunma)
export function fileUrl(base, path) {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  return `${(base || '').replace(/\/+$/, '')}${path}`;
}
